// extracted by mini-css-extract-plugin
module.exports = {"info":"styles-module--info--38FSY"};